import * as Sentry from "@sentry/react";
import { type PropsWithChildren, type ReactNode } from "react";

import { CONTEXT_APP, TAG_FEATURE } from "./const";
import { useSentryContext } from "./sentry-context-value";
import { SentryErrorPage } from "./sentry-error-page";
import { type SentryErrorBoundaryDataType } from "./types/sentry-error-boundary-data";
import { captureSentryErrorScreenshot } from "./utils/capture-error-screenshot";

export function SentryErrorBoundary({
  children,
  feature,

  contexts,
  actions,
}: PropsWithChildren<SentryErrorBoundaryDataType & { actions?: ReactNode }>) {
  const enableFeedback = useSentryContext()?.enableFeedback ?? false;

  return (
    <Sentry.ErrorBoundary
      beforeCapture={(scope) => {
        scope.setTag(TAG_FEATURE, feature);
        scope.setContext(CONTEXT_APP, contexts ?? {});
      }}
      onError={
        enableFeedback
          ? (_, __, eventId) => {
              void captureSentryErrorScreenshot(eventId);
            }
          : undefined
      }
      fallback={(props) => (
        <SentryErrorPage
          {...props}
          actions={actions}
          enableFeedback={enableFeedback}
        />
      )}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
